<template>
  <div>
    <v-card class="px-0 ma-1 elevation-10">
      <v-card-title>
        <v-btn @click="getCustomers">Get Data</v-btn>
        <v-btn @click="downloadTable">Download Table</v-btn>
        <v-btn @click="manualGetGeocode">Manual Get</v-btn>
      </v-card-title>
      <v-card-text> <div id="table"></div></v-card-text>
    </v-card>
  </div>
</template>

<script>
import firebase from "@/configFirebase";
import Tabulator from "tabulator-tables";

export default {
  data: () => ({
    table: null,
    tableColumns: [],
    clientId: "",
    orgName: "",
    custList: [],
  }),
  methods: {
    getCustomers() {
      //get all customers
      firebase.db
        .collection(this.clientId + this.orgName + "customers")
        .onSnapshot((snapcust) => {
          let custList = [];
          let branch = [];
          this.custList = [];

          snapcust.forEach((cust) => {
            if (
              cust.data().category !== "RETAIL - NONACTIVE" ||
              cust.data().category !== "RESTAURANT - NONACTIVE"
            ) {
              if (cust.data().branches) {
                branch = Object.values(cust.data().branches);
              } else {
                branch = [0];
              }
              if (cust.data().area) {
                this.custList.push({
                  custno: cust.data().custno,
                  active: cust.data().active,
                  area: Object.keys(cust.data().area),
                  category: cust.data().category,
                  contact: cust.data().contact,
                  creditlimit: cust.data().creditlimit,
                  address: cust.data().address,
                  name: cust.data().name,
                  geolocation: cust.data().geolocation,
                  pricelist: cust.data().pricelist,
                  tel1: cust.data().tel1,
                  tel2: cust.data().tel2,
                  branches: branch,
                });
              } else {
                this.custList.push({
                  custno: cust.data().custno,
                  active: cust.data().active,
                  area: [],
                  category: cust.data().category,
                  contact: cust.data().contact,
                  creditlimit: cust.data().creditlimit,
                  address: cust.data().address,
                  name: cust.data().name,
                  geolocation: cust.data().geolocation,
                  pricelist: cust.data().pricelist,
                  tel1: cust.data().tel1,
                  tel2: cust.data().tel2,
                  branches: branch,
                });
              }
            }
          });
          this.createTable();
        });
    },
    async createTable() {
      this.tableColumns = [];
      this.tableData = [];

      for (let cust of this.custList) {
        if (
          cust.category !== "RETAIL - NONACTIVE" &&
          cust.category !== "RESTAURANT - NONACTIVE" &&
          cust.category !== "ECOMMERCE" &&
          cust.category !== "RETAIL - PROSPECT" &&
          cust.category !== "RESTAURANT - PROSPECT" &&
          cust.category !== "RETAIL - CLOSE" &&
          cust.category !== "RESTAURANT - CLOSE" &&
          cust.category !== "HYPERMARKET - CLOSE"
        ) {
          if (cust.branches.length > 1) {
            for (let branch of cust.branches) {
              this.tableData.push({
                category: cust.category,
                custno: cust.custno,
                name: cust.name,
                branchno: branch.branchno ? branch.branchno : "",
                address: branch.address ? branch.address.replace("&", " ") : "",
                geolocation: branch.geolocation ? branch.geolocation : "",
              });
            }
          } else {
            this.tableData.push({
              category: cust.category,
              custno: cust.custno,
              name: cust.name,
              branchno: cust.custno,
              address: cust.address ? cust.address.replace("&", " ") : "",
              geolocation: cust.geolocation ? cust.geolocation : "",
            });
          }
        }
      }

      console.log(this.tableData);
      let self = this;

      this.tableColumns = [
        {
          title: "Category",
          field: "category",
        },
        {
          title: "No.",
          field: "custno",
        },
        {
          title: "Name",
          field: "name",
        },
        {
          title: "Ship To Location",
          field: "branchno",
        },
        {
          title: "Address",
          field: "address",
        },
        {
          title: "Get",
          cellClick: function(e, cell) {
            let rowData = cell.getRow().getData();

            self.getGeocode(rowData);
          },
        },
        {
          title: "Latitude",
          field: "latitude",
        },
        {
          title: "Longitude",
          field: "longitude",
        },
        {
          title: "Original Geolocation",
          field: "geolocation",
        },
      ];

      this.table = null;

      this.table = new Tabulator("#table", {
        height: "100%",
        movableColumns: false,
        //dataTree: true,
        layout: "fitColumns",
        layout: "fitDataFill",
        //layout: "fitDataStretch",
        //responsiveLayout: "collapse",
        //responsiveLayoutCollapseStartOpen: false,
        pagination: "local",
        paginationSize: 10,
        paginationSizeSelector: [5, 10, 20, 30, 40, 50, 100, 500, 1000],
        clipboard: true,
        clipboardCopyStyled: false,
        //rowContextMenu: this.tableContextMenu,
        columns: this.tableColumns,
        data: this.tableData,
        index: "branchno",
      });

      let myitems = [];
      for (let i = 0; i <= this.tableData.length; i++) {
        myitems.push(this.tableData[i]);
      }

      const axios = require("axios");

      /*await myitems.reduce(async (memo, i) => {
        console.log(i);
        await memo;
        await new Promise((r) => setTimeout(r, 500));

        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${i.address}&key=AIzaSyC-nqaUu-LJc-Jqp5i2oGy8Ng53dEfF6VU`
          )
          .then((res) => {
            if (res) {
              console.log(i.branchno);
              console.log(res.data.results[0].geometry.location);

              this.table.updateData([
                {
                  branchno: i.branchno,
                  latitude: res.data.results[0].geometry.location.lat,
                  longitude: res.data.results[0].geometry.location.lng,
                },
              ]);
            }
          });

        //await this.getGeocode(i);
      }, undefined);*/
      console.log("Finished");
      this.table.addRow();
    },
    getGeocode2(rowData) {
      let address = rowData.address;

      let custIndex = this.tableData.findIndex(
        (i) => i.name === rowData.name && i.branchno === rowData.branchno
      );

      const geocoder = new google.maps.Geocoder();

      return new Promise((resolve, reject) => {
        geocoder.geocode(
          {
            address: address,
          },
          (results, status) => {
            if (status === "OK") {
              console.log(rowData.branchno);
              this.table.updateData([
                {
                  branchno: rowData.branchno,
                  latitude: results[0].geometry.location.lat(),
                  longitude: results[0].geometry.location.lng(),
                },
              ]);
              resolve(results);
            } else {
              console.log(rowData.branchno);
              this.table.updateData([
                {
                  branchno: rowData.branchno,
                  latitude: results[0].geometry.location.lat(),
                  longitude: results[0].geometry.location.lng(),
                },
              ]);
              resolve(results);
              /*if ((status = "OVER_QUERY_LIMIT")) {
            alert("reason" + status);
          }*/
            }
          }
        );
      });
    },
    getGeocode(rowData) {
      if (rowData.address !== "") {
        let address = rowData.address;

        let custIndex = this.tableData.findIndex(
          (i) => i.name === rowData.name && i.branchno === rowData.branchno
        );

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address }, (results, status) => {
          if (status === "OK") {
            console.log(rowData.branchno);
            this.table.updateData([
              {
                branchno: rowData.branchno,
                latitude: results[0].geometry.location.lat(),
                longitude: results[0].geometry.location.lng(),
              },
            ]);
          } else {
            console.log(status);
            this.table.updateData([
              {
                branchno: rowData.branchno,
                latitude: results[0].geometry.location.lat(),
                longitude: results[0].geometry.location.lng(),
              },
            ]);
            /*if ((status = "OVER_QUERY_LIMIT")) {
            alert("reason" + status);
          }*/
          }
          //this.table.replaceData(this.tableData);
        });
      }
    },
    async manualGetGeocode() {
      let myitems = [];
      this.tableData = this.table.getData();
      for (let i = 0; i <= this.tableData.length; i++) {
        myitems.push(this.tableData[i]);
      }

      const axios = require("axios");

      await myitems.reduce(async (memo, i) => {
        //console.log(i);
        await memo;
        await new Promise((r) => setTimeout(r, 2000));

        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${i.address}&key=AIzaSyC-nqaUu-LJc-Jqp5i2oGy8Ng53dEfF6VU`
          )
          .then((res) => {
            if (res) {
              console.log(i.branchno);
              console.log(res.data.results[0].geometry.location);

              this.table.updateData([
                {
                  branchno: i.branchno,
                  latitude: res.data.results[0].geometry.location.lat,
                  longitude: res.data.results[0].geometry.location.lng,
                },
              ]);
            }
          });

        //await this.getGeocode(i);
      }, undefined);
    },
    downloadTable() {
      this.table.download("csv", `${this.orgName}Geolocation.csv`, {
        delimiter: "\t",
      });
    },
  },
  async mounted() {
    /*firebase.auth
      .signInWithEmailAndPassword("admin1prai@jasmine.com.my", "888888")
      .then((res) => {
        //console.log(res);
        firebase.db
          .collection("users")
          .doc(res.user.uid)
          .onSnapshot((snap) => {
            //get clientId and orgName
            this.clientId = Object.values(snap.data().client)[0].shortname;
            this.orgName = Object.values(snap.data().org)[0].org;
          });
      });*/
    this.createTable();
  },
};
</script>

<style scoped>
@import "~tabulator-tables/dist/css/tabulator_simple.css";
</style>
